import { render, staticRenderFns } from "./TranslateListView.vue?vue&type=template&id=1acc394e"
import script from "./TranslateListView.vue?vue&type=script&lang=js"
export * from "./TranslateListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports